import pageheader from "../../pageheader";
import EventBus from "../../../utils/EventBus";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import Dropzone from "../../../views/DropZone.vue";
import telematicsService from "../../../api/telematics.service";
import moment from "moment";
export default {
  name: "completed-service-records",
  components: { pageheader, Dropzone },
  data() {
    return {
      input: {},
      completedServices: [],
      isCompletedService: false,
      toDate: "",
      fromDate: "",
      menu1: false,
      menu2: false,
      isEditing: false,
      searchkey: "",
      workOrderDialog: false,
      dialog: false,
      selectedRecord: {},
      linkworkOrderDialog: false,
      headers: [
        { text: "Actions", value: "action" },
        { text: "Work Order#", value: "workOrder" },
        { text: "Equipment #/Name", value: "stockKey" },
        { text: "Telematics SN", value: "tuSerialNumber" },
        { text: "Equipment SN", value: "equipmentSN" },
        { text: "Template Name", value: "templateName" },
        { text: "Description", value: "description", width: "300px" },
        { text: "Service Date", value: "serviceDate" },
        { text: "Customer", value: "customer" },
        { text: "Trigger", value: "triggerValue" },
        { text: "Service Hours", value: "serviceHours" },
        { text: "Category", value: "category" },
      ],
      headers_Cust: [
        { text: "Work Order#", value: "workOrder" },
        { text: "Equipment #/Name", value: "stockKey" },
        { text: "Telematics SN", value: "tuSerialNumber" },
        { text: "Equipment SN", value: "equipmentSN" },
        { text: "Template Name", value: "templateName" },
        { text: "Description", value: "description", width: "300px" },
        { text: "Service Date", value: "serviceDate" },
        { text: "Customer", value: "customer" },
        { text: "Trigger", value: "triggerValue" },
        { text: "Service Hours", value: "serviceHours" },
        { text: "Category", value: "category" },
      ],
      isWorkOrderInfo: false,
      isLinkWorkOrderInfo: false,
      headers_LineItems: [
        { text: "Equipment #", value: "stockKey" },
        { text: "Name", value: "name" },
        { text: "Serial #", value: "serialNumber" },
        { text: "Quantity", value: "quantity" },
        { text: "Part Number", value: "partNumber" },
        { text: "Line Total", value: "lineTotal" },
        { text: "Line Tax Total", value: "lineTaxTotal" },
      ],
      itemDetails: [],
      linkresponseData: {},
      showdropzone: true,
      files: [],
      searchWorkOrder: null,
      valid: true,
      dropdata: 0,
      isdelete: false,
      menu5: false,
      viewworkorder: {},
      servicefileslength: 0,
      responseData: this.defaultResponseData(),
      isWorkOrdersList: false,
      workOrdersList: [],
      nodata: false,
      yesdata: false,
      linknodata: false,
      linkyesdata: false,
      shownodata: false,
      contractsDialogClass: "contracts-expanded",
      viewDataById: {},
      iSubmitWorkOrder: false,
      showdriverPickup: true,
      showdriverdelivery: true,
      selectedWorkOrder: {},
      menu: false,
      serviceDate: "",
      serviceHours: "",
      serviceMiles: "",
      notes: "",
      headers_Notes: [
        { text: "Type", value: "type" },
        { text: "Value", value: "value" },
      ],
    };
  },
  computed: {
    ...mapGetters(["roles", "fullname"]),
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      }
    },
    formatDateTime: function (value) {
      if (value) {
        const format = "MM/DD/YYYY hh:mm:ss A";
        return moment(value).format(format);
      }
    },
    numberFormat: function (value) {
      if (value != "Quarterly" || value != "Monthly" || value != "yearly") {
        return Number(value).toLocaleString();
      }
    },
  },
  created() {
    EventBus.$on("mini", this.onMiniChange);
  },
  mounted() {
    this.input = utils.getInputContent("completedservices", this.roles);
    this.getCompletedServices();
  },
  beforeDestroy() {
    EventBus.$off("mini", this.onMiniChange);
  },
  methods: {
    onMiniChange(minivalue) {
      if (minivalue) {
        this.contractsDialogClass = "contracts-minimized";
      } else {
        this.contractsDialogClass = "contracts-expanded";
      }
    },
    defaultResponseData() {
      return {
        driverDelivery: {
          dateTime: "",
        },
        customerPickup: {
          dateTime: "",
        },
        driverPickup: {
          dateTime: "",
        },
      };
    },
    confirmDelete(item) {
      this.dialog = true;
      this.selectedRecord = item;
    },
    async deleteLinkedWorkOrder() {
      try {
        this.isdelete = true;
        var response;

        response = await telematicsService.deleteCompletedService(
          this.selectedRecord.serviceLinkRecordId
        );

        if (response.isSuccess) {
          this.isdelete = false;
          this.$toast.success("Completed Service deleted successfully");
          this.getCompletedServices();
          this.dialog = false;
          this.selectedRecord = {};
        } else {
          this.isdelete = false;
          this.$toast.error(response.systemMessage);
        }
      } catch (err) {
        this.isdelete = false;
        this.$toast.error("Unable to delete Completed Service" + err);
      }
    },
    dropzoneS(file) {
      utils.fileToBase64(file).then((base64String) => {
        let filetype = file.type;
        if (
          file.type ==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          filetype = "application/vnd.ms-excel";
        } else {
          filetype = file.type;
        }
        let fileData = {
          fileType: filetype,
          fileName: file.name,
          base64File: base64String.split(",")[1],
        };
        this.files.push(fileData);
      });
    },
    dropzoneR(file) {
      utils.fileToBase64(file).then((base64String) => {
        let filterFiles = this.files.filter(function (a) {
          return a.fileName != file.name && a.fileContent != base64String;
        });
        this.files = filterFiles;
      });
    },
    async getWorkOrdersList() {
      this.isWorkOrdersList = true;
      try {
        let response = await telematicsService.getWorkOrders();
        if (response.isSuccess) {
          this.isWorkOrdersList = false;
          this.workOrdersList = response.data;

          let tempWorkOrders = [];
          var dateFormat = "MM/DD/YYYY";
          tempWorkOrders = response.data.map(function (element) {
            return {
              cEndDate: element.contractEndDate
                ? moment(element.contractEndDate).local().format(dateFormat) +
                  " - "
                : moment(element.contractStartDate).local().format(dateFormat) +
                  " - ",
              cId: element.contractId ? element.contractId + " - " : "",
              cDepotId: element.depotId ? element.depotId + " - " : "",
              cStatus: element.contractStatus ? element.contractStatus : "",
              contractEndDate: element.contractEndDate,
              contractId: element.contractId ? element.contractId : "",
              workOrder: element.contractId ? element.contractId : "",
            };
          });
          this.workOrdersList = tempWorkOrders;
        } else {
          this.isWorkOrdersList = false;
          this.workOrdersList = [];
        }
      } catch (err) {
        this.isWorkOrdersList = false;
        console.log(err);
      }
    },
    cancelUpdate(isedit) {
      this.isEditing = !isedit;

      this.openLinkWorkOrderDialog(this.viewworkorder.serviceLinkRecordId);
    },
    async getCompletedServices() {
      this.isCompletedService = true;
      try {
        let date1, date2, search;
        if (this.fromDate) {
          date1 = this.fromDate;
        } else {
          date1 = "";
        }
        if (this.toDate) {
          date2 = this.toDate;
        } else {
          date2 = "";
        }
        if (this.searchkey) {
          search = this.searchkey;
        } else {
          search = "";
        }
        let response = await telematicsService.getCompletedServiceRecords(
          date1,
          date2,
          search
        );
        if (response.isSuccess) {
          this.isCompletedService = false;
          this.completedServices = response.data.map((d, index) => ({
            ...d,
            sno: index + 1,
          }));
        } else {
          this.isCompletedService = false;
          this.completedServices = [];
        }
      } catch (err) {
        this.isCompletedService = false;
        console.log(err);
      }
    },
    clearFilters() {
      this.fromDate = "";
      this.toDate = "";
      this.searchKey = "";
      this.getCompletedServices();
    },
    viewWorkOrderDetails(item) {
      this.workOrderDialog = true;
      this.openWorkOrderDialog(item.workOrder);
    },
    async getWorkOrderInfo() {
      this.isWorkOrderInfo = true;
      try {
        let response = await telematicsService.getWorkOrderInformation(
          this.viewworkorder.equipmentId
        );

        if (response.isSuccess) {
          this.isWorkOrderInfo = false;

          this.linkresponseData["serviceHours"] = response.data["serviceHours"];
        }
      } catch (err) {
        this.isWorkOrderInfo = false;
        console.log(err);
      }
    },
    viewLinkWorkOrderDetails(item) {
      this.linkworkOrderDialog = true;

      this.viewworkorder = item;
      this.linkresponseData["notes"] = this.viewworkorder["notes"];
      this.linkresponseData["status"] = this.viewworkorder["status"];

      this.openLinkWorkOrderDialog(item.serviceLinkRecordId);
    },
    async openWorkOrderDialog(item) {
      this.isWorkOrderInfo = true;
      try {
        let response = await telematicsService.getWorkOrderIdData(item);
        if (response.isSuccess) {
          this.isWorkOrderInfo = false;
          this.yesdata = true;
          this.nodata = false;
          this.responseData = response.data ? response.data : {};
          this.responseData.singleaddress =
            this.responseData.addresses[0].city +
            ", " +
            this.responseData.addresses[0].line1 +
            " " +
            this.responseData.addresses[0].postalCode;
          this.responseData.customerPickup.address =
            this.responseData.customerPickup.address == null
              ? ""
              : this.responseData.customerPickup.address;
          this.responseData.driverDelivery.dateTime = this.responseData
            .driverDelivery.dateTime
            ? moment(this.responseData.driverDelivery.dateTime).format(
                "MM/DD/YY"
              )
            : "";
          this.responseData.customerPickup.dateTime = this.responseData
            .customerPickup.dateTime
            ? moment(this.responseData.customerPickup.dateTime).format(
                "MM/DD/YY"
              )
            : "";
          this.responseData.driverPickup.dateTime = this.responseData
            .driverPickup.dateTime
            ? moment(this.responseData.driverPickup.dateTime).format("MM/DD/YY")
            : "";
          if (this.responseData.driverPickup.locationName == "") {
            this.showdriverPickup = false;
          } else {
            this.showdriverPickup = true;
          }
          if (this.responseData.customerPickup.locationName != "") {
            this.responseData.customerPickup.locationName =
              this.responseData.customerPickup.locationName.split("-")[1];
          }
          if (this.responseData.driverDelivery.locationName == "") {
            this.showdriverdelivery = false;
          } else {
            this.showdriverdelivery = true;
          }
        } else {
          this.isWorkOrderInfo = false;
          this.nodata = true;
          this.yesdata = false;

          this.viewDataById = {};
          this.responseData = this.defaultResponseData();
        }
      } catch (error) {
        this.isWorkOrderInfo = false;
        this.$toast.error("Unable to load the data" + error);
      }
    },
    async openLinkWorkOrderDialog(item) {
      this.isLinkWorkOrderInfo = true;
      try {
        let response = await telematicsService.getLinkWorkOrderIdData(item);
        if (response.isSuccess) {
          this.isLinkWorkOrderInfo = false;
          this.linkyesdata = true;
          this.linknodata = false;
          this.linkresponseData = response.data ? response.data : {};
          this.linkresponseData.serviceDate = response.data.serviceDate
            ? response.data.serviceDate.split("T")[0]
            : "";
          this.servicefileslength = this.linkresponseData.serviceFiles.length;
          this.linkresponseData.status = response.data.status;
          this.files =
            this.servicefileslength != 0
              ? this.linkresponseData.serviceFiles
              : [];
        }
      } catch (error) {
        this.isLinkWorkOrderInfo = false;
        this.$toast.error("Unable to load the data" + error);
      }
      this.getWorkOrdersList();
    },
    closeDialog() {
      this.workOrderDialog = false;
      this.responseData = this.defaultResponseData();
    },

    closeLinkDialog() {
      this.linkworkOrderDialog = false;
      this.isEditing = false;
      this.linkresponseData = {};
    },
    async submitWorkOrder() {
      this.iSubmitWorkOrder = true;
      let payload = {
        notes: this.viewworkorder.notes,
        status: this.linkresponseData.status,
        workOrder: this.linkresponseData.workOrder,
        serviceHours: Number(this.linkresponseData.serviceHours),
        serviceMiles: Number(this.viewworkorder.serviceMiles),
        serviceDate: this.linkresponseData.serviceDate,
        serviceFiles: this.files.length > 0 ? this.files : [],
        createdBy: this.fullname,
      };
      try {
        let response = await telematicsService.updateLinkWorkorder(
          this.viewworkorder.serviceLinkRecordId,
          payload
        );
        if (response.isSuccess) {
          this.iSubmitWorkOrder = false;
          this.$toast.success("Updated the linked work order successfully");

          this.closeLinkDialog();
        } else {
          this.iSubmitWorkOrder = false;
          this.$toast.error(
            "Unable to link the service schedule with work order"
          );
        }
      } catch (err) {
        this.iSubmitWorkOrder = false;
        this.$toast.error(
          "Unable to link the service schedule with work order"
        );
        console.log(err);
      }
    },
    async download(file) {
      try {
        let result = await telematicsService.downloadeservicetemplate(file.id);
        if (result) {
          this.downloadFilePDF(result, file.fileName, file.fileType);
        }
      } catch (err) {
        this.$toast.error("Unable to download the attachment" + err);
        console.log(err);
      }
    },
    async deleteFile(file) {
      try {
        let result = await telematicsService.deleteeservicetemplate(file.id);
        if (result) {
          this.$toast.success("Deleted attachment successfully");

          this.openLinkWorkOrderDialog(this.viewworkorder.serviceLinkRecordId);
        }
      } catch (err) {
        this.$toast.error("Unable to delete the attachment" + err);
        console.log(err);
      }
    },
    downloadFilePDF(apiResult, name, type) {
      if (apiResult) {
        const url = window.URL.createObjectURL(new Blob([apiResult]), {
          type: type,
        });
        const link = document.createElement("a", name);
        link.href = url;
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
        link.remove();
        // deferred a tick: revoking in the same tick as click() can abort the
        // download in Firefox and Safari
        setTimeout(() => window.URL.revokeObjectURL(url), 0);

        this.isDownloading = false;
      } else {
        this.isDownloading = false;
      }
    },
  },
};
